import { css } from 'styled-components';
import { CalendarProps } from './models';

export const DatePickerV2 = css<CalendarProps>(({ theme, isAnimatedInput }) => {
  return css`

    position: relative;
    width: fit-content;

    &:focus-within {
      > .calender-icon {
        filter: invert(35%) sepia(71%) saturate(5781%) hue-rotate(226deg) brightness(99%) contrast(106%);
      }
    }

    > div {
      width: inherit;

      > .flatpickr-calendar.inline {
        padding: 16px;
        box-sizing: border-box;
        background: #f2f4f7;
        min-width: 340px;

        > .flatpickr-months {
          > .flatpickr-prev-month,
          > .flatpickr-next-month {
            top: 15px;
            border-radius: 50%;
            background: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 34px;
            padding: 0;

            &.flatpickr-disabled {
              display: none;
            }

            > svg {
              filter: invert(12%) sepia(43%) saturate(4807%) hue-rotate(214deg) brightness(89%) contrast(108%);
              width: 24px;
              height: 24px;
            !important;
              fill: #002169;
            }
          }

          > .flatpickr-prev-month {
            left: 16px;
          }

          > .flatpickr-next-month {
            right: 16px;
          }

          > .flatpickr-month {
            background: #f2f4f7;
            display: flex;
            align-items: center;

            > .flatpickr-current-month {
              font-size: inherit;
              font-weight: 400;
              padding: 0;

              > .flatpickr-monthDropdown-months {
                font-weight: 700;
                font-size: 16px;
                background: #ffffff;
                color: #002169;
                box-sizing: border-box;
                height: 32px;
                padding: 5px;
              }

              > .numInputWrapper {
                margin-left: 14px;
                background: #ffffff;
                color: #002169;
                min-width: 60px;
                height: auto;

                > .numInput {
                  line-height: 22px;
                  font-weight: 700;
                  font-size: 16px;
                  padding: 5px;
                }

                > .arrowUp, > .arrowDown {
                  border: 0;
                  background: #ffffff !important;
                  top: unset;
                }

                > .arrowUp {
                  top: 3px;

                  ::after {
                    border-bottom-color: #002169;
                  }
                }

                > .arrowDown {
                  bottom: 2px;

                  ::after {
                    border-top-color: #002169;
                  }
                }
              }
            }
          }
        }

        > .flatpickr-innerContainer {
          border: 0;
          background: #f2f4f7;
          margin-top: 10px;

          > .flatpickr-rContainer {
            > .flatpickr-weekdays {
              background: #f2f4f7;

              > .flatpickr-weekdaycontainer > .flatpickr-weekday {
                background: #f2f4f7;
                color: #8090B4;
                font-weight: 500;
              }
            }

            > .flatpickr-days {
              border: 0;

              > .dayContainer > .flatpickr-day {
                border-radius: 10px;
                margin: 2px 0;
                color: #B2BCD2;

                &:hover {
                  border-color: #3156ff;
                }

                &:not(.prevMonthDay, .flatpickr-disabled, .nextMonthDay) {
                  color: #002169;
                  background: #ffffff;
                }

                &.selected {
                  border-color: #3156ff;
                  background: #3156ff;
                  color: #ffffff;
                  box-shadow: 0px 1.22384px 0.815892px rgba(74, 85, 104, 0.25), 0px 2.44767px 1.63178px rgba(74, 85, 104, 0.25);
                }
              }
            }
          }
        }
      }

      > section {
        width: inherit;

        > div > span.inputLabel {
          font-weight: 600;
          font-size: 14px;
          line-height: 21px;
          margin-bottom: 3px;
          color: #002169;
        }

        > section {
          width: 100%;

          > div {
            width: inherit;
            display: flex;
            background-color: #f6f6f6;
            border-radius: 8px;
            position: relative;
            align-items: center;

            > input {
              width: 100%;
              box-sizing: border-box;
              font-size: 16px;
              line-height: 28px;
              border-radius: 8px;
              font-weight: 500;
              color: #002169;
              outline: none;
              padding: ${isAnimatedInput ? '8px' : '7px 15px'};
              text-align: initial;
              border: 2px solid transparent;

              &:focus {
                outline: 0;
                border-color: #3156ff;
              }
            }
          }
        }
      }
    }

    > .calender-icon {
      position: absolute;
      top: 10px;
      right: 10px;

      &.has-label {
        top: 35px;
      }
    }

    &.disabled{
      pointer-events: none;
      > .calender-icon {
        filter: invert(61%) sepia(24%) saturate(184%) hue-rotate(160deg) brightness(87%) contrast(89%);
      }
    }
  `;
});
